module.exports = __webpack_public_path__ + "media/images/upvote_chevron-139ec6afa8d65d626cf4a490f6cb07db.svg";